<template>
  <div class="ctr">
    <!-- <menu-left /> -->
    <left-panel />
    <router-view />
    <!-- <right-panel /> -->
    <!-- <list-dialog /> -->
  </div>
</template>
<script>
import LeftPanel from './LeftPanel'
// import ListDialog from '@views/components/ListDialog'

export default {
  name: 'layout',
  components: {
    LeftPanel,
    // ListDialog,
  },
}
</script>


